/**
 * 제조처리 API 클라이언트 — backend /manufactures/* 와 1:1.
 *
 * 권한:
 *   - 조회: 모든 로그인 사용자 (재고 도메인 규칙)
 *   - 제조 처리 / 분해: sales + admin
 */

import { api } from './api';
import type {
  ManufactureCreateInput,
  ManufactureCreateResult,
  ManufactureDetail,
  ManufactureRow,
  StockNegativeWarning,
} from './types';

const BASE = '/manufactures';

export async function listManufactures(params?: {
  q?: string;
  status?: '완료' | '취소';
}): Promise<ManufactureRow[]> {
  const qs = new URLSearchParams();
  if (params?.q?.trim()) qs.set('q', params.q.trim());
  if (params?.status) qs.set('status', params.status);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return api.get(`${BASE}${suffix}`);
}

export async function getManufacture(manufactureId: number): Promise<ManufactureDetail> {
  return api.get(`${BASE}/${manufactureId}`);
}

/** 매입행 → 제조 연결 조회. 연결 없으면 null (완제품행·원재료행 양쪽에서 동작). */
export async function getByPurchase(
  purchaseId: number,
): Promise<{ manufactureId: number; role: 'product' | 'input' } | null> {
  return api.get(`${BASE}/by-purchase/${purchaseId}`);
}

export async function createManufacture(
  input: ManufactureCreateInput,
): Promise<ManufactureCreateResult> {
  return api.post(BASE, input);
}

/** 분해 — 만들어 둔 완제품을 다시 원재료로 되돌린다 (제조한 묶음 통째로). */
export async function disassembleManufacture(
  manufactureId: number,
): Promise<{ manufactureId: number; warnings: StockNegativeWarning[] }> {
  return api.post(`${BASE}/${manufactureId}/disassemble`, {});
}
